import VehicleTypesBin from './VehicleTypesBin'

export default VehicleTypesBin
